import React, { FunctionComponent, ReactNode, useEffect, useMemo, useState } from 'react';
import { Badge, Button, Popover } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import { useLocation } from 'react-router-dom';
import SpamSelector from '@components/SpamSelector';
import css from './SpamPageLayout.module.less';

interface SpamPageLayoutProps {
  filters?: ReactNode;
  children: ReactNode;
  filterTrigger?: ReactNode;
  hasActiveFilters?: boolean;
}

const SpamPageLayout: FunctionComponent<SpamPageLayoutProps> = ({
  filters,
  children,
  filterTrigger,
  hasActiveFilters = false,
}) => {
  const location = useLocation();
  const [isFiltersOpened, setIsFiltersOpened] = useState(false);

  useEffect(() => {
    setIsFiltersOpened(false);
  }, [location.pathname]);

  const defaultFilterTrigger = useMemo(() => {
    if (!filters) {
      return null;
    }

    return (
      <Popover
        key={location.pathname}
        trigger='click'
        placement='bottomLeft'
        visible={isFiltersOpened}
        onVisibleChange={setIsFiltersOpened}
        overlayClassName={css.filtersPopover}
        destroyTooltipOnHide
        getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
        content={<div className={css.filtersPopoverContent}>{filters}</div>}
      >
        <Button
          className={css.filtersButton}
          icon={
            <Badge
              dot={hasActiveFilters}
              offset={[-1, 3]}
            >
              <FilterOutlined className={css.filtersIcon} />
            </Badge>
          }
        >
          Фильтры
        </Button>
      </Popover>
    );
  }, [filters, hasActiveFilters, isFiltersOpened, location.pathname]);

  const resolvedFilterTrigger = filterTrigger || defaultFilterTrigger;

  return (
    <div className={css.root}>
      <div className={css.topBar}>
        {resolvedFilterTrigger ? (
          <div className={css.filterTrigger}>{resolvedFilterTrigger}</div>
        ) : null}

        <div className={css.selector}>
          <SpamSelector />
        </div>
      </div>

      <div className={css.content}>{children}</div>
    </div>
  );
};

export default SpamPageLayout;
